/* global google */
import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';

export default function guideBeachRivieraMap(mapElement, markers, beachRivieraMap, bounds) {
    const backUrl = mapElement.getAttribute('data-backurl');
    const backLinkTitle = mapElement.getAttribute('data-backlinktitle');
    const dataMarkers = JSON.parse(mapElement.getAttribute('data-gmap-markers'));

    putMarkersOnMap(beachRivieraMap, markers, dataMarkers, bounds, mapElement);

    const backLink = document.createElement('a');
    backLink.setAttribute('href', backUrl);

    const backLinkContent = document.createElement('div');
    backLinkContent.setAttribute('class', 'backUrl');
    backLinkContent.innerHTML = backLinkTitle;
    backLinkContent.index = 1;

    backLink.appendChild(backLinkContent);
    beachRivieraMap.controls[google.maps.ControlPosition.TOP_CENTER].push(backLink);
}

export function putMarkersOnMap(beachRivieraMap, markers, dataMarkers, bounds, mapElement) {
    const iconBeach = mapElement.getAttribute('data-beachicon');
    const iconBeachActive = mapElement.getAttribute('data-beachactiveicon');
    const iconFacility = mapElement.getAttribute('data-facilityicon');
    const markerInfoUrl = mapElement.getAttribute('data-markerinfourl');
    const infowindow = new google.maps.InfoWindow({ maxWidth: 400 });

    $.each(dataMarkers, (id, value) => {
        let markerIcon = null;
        if (value.type === 'beach') {
            markerIcon = iconBeach;
        } else if (value.type === 'facility') {
            markerIcon = iconFacility;
        } else if (value.type === 'beachActive') {
            markerIcon = iconBeachActive;
        }

        const markerPosition = new google.maps.LatLng(value.lat, value.lng);
        bounds.extend(markerPosition);
        const marker = new google.maps.Marker({
            position: markerPosition,
            map: beachRivieraMap,
            icon: markerIcon,
            clickable: true,
            title: value.title,
        });

        google.maps.event.addListener(marker, 'click', () => {
            infowindow.setContent('<div class="loader32w" style="display:block;"></div>');
            infowindow.open(beachRivieraMap, marker);
            const infoUrl = markerInfoUrl.replace('__TYPE__', value.type).replace('__ID__', value.id);

            $.get(infoUrl).done((markerContent) => {
                infowindow.setContent(markerContent);
                if (value.type === 'beach') {
                    setUpBeachInfoGallery();
                }
            });
        });

        markers.push(marker);
    });

    beachRivieraMap.fitBounds(bounds); // auto-zoom
    beachRivieraMap.panToBounds(bounds); // auto-center
}

export function cleanMarkers(markers) {
    for (let i = 0; i < markers.length; i += 1) {
        markers[i].setMap(null);
    }
}

function setUpBeachInfoGallery() {
    $('.geosearchBeachInfoSimpleGallery').toArray().forEach((galleryElement) => {
        const $galleryContainer = $(galleryElement);
        createSimplePrivateGallery({
            source: $galleryContainer.data('source').map((image) => ({ url: image.standard })),
            nextButton: $galleryContainer.find('.simpleGalleryNext')[0],
            previousButton: $galleryContainer.find('.simpleGalleryPrev')[0],
            counterElement: $galleryContainer.find('.simpleGalleryCounter')[0],
            imageElement: $galleryContainer.find('.currentImage img')[0],
        });
    });
}
